import { render, staticRenderFns } from "./MxInfoButton.vue?vue&type=template&id=3642a350"
import script from "./MxInfoButton.vue?vue&type=script&lang=ts"
export * from "./MxInfoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports